import { render, staticRenderFns } from "./CustomerPartnerUpdate.vue?vue&type=template&id=02be6a87&scoped=true"
import script from "./CustomerPartnerUpdate.vue?vue&type=script&lang=js"
export * from "./CustomerPartnerUpdate.vue?vue&type=script&lang=js"
import style0 from "./CustomerPartnerUpdate.vue?vue&type=style&index=0&id=02be6a87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02be6a87",
  null
  
)

export default component.exports